import { getFileSourceType } from '@shoflo/polymer';
import { withCurrentParams } from 'actions/utils';
import { SOURCE_CREATE } from 'store/eventConstants';
import { BROADCAST_CREATE_SOURCE } from 'actions/Types';
import { getSignedUrl } from 'utils/broadcastSourceHelper';

export default (eventDoc, { title, order }) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        meeting: { attendeeResponse }
      } = getState();
      const action = {
        type: BROADCAST_CREATE_SOURCE,
        request: async apiClient => {
          const payload = {
            type: getFileSourceType(title),
            title,
            order,
            value: {
              eventDocId: eventDoc._id
            }
          };

          const response = await apiClient.broadcast.createSource(
            teamId,
            eventId,
            broadcastId,
            payload
          );

          const createdSource = await getSignedUrl(response, apiClient);
          socket.emit(SOURCE_CREATE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          return createdSource;
        }
      };
      dispatch(action);
    }
  );
};
